import { get } from "lodash";
export const AUTH_WRONG_URL_ERROR_CODE = "auth/wrong-url";
export const isWrongUrlError = error => get(error, "errors[0].code") === AUTH_WRONG_URL_ERROR_CODE || get(error, "errors[0].errorCode") === AUTH_WRONG_URL_ERROR_CODE;
export const getUserAuthFormError = error => {
  if (error.name === "HttpClientError") {
    error = error.errors[0];
  }

  return error.message || "Failed to authorise user";
};